var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircle = function SvgCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#F4F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 34H48L45 30L42 34ZM42 38H48L45 42L42 38Z",
    fill: "#FEE093"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24H31V48H25C24.7348 48 24.4804 47.8946 24.2929 47.7071C24.1054 47.5196 24 47.2652 24 47V25C24 24.7348 24.1054 24.4804 24.2929 24.2929C24.4804 24.1054 24.7348 24 25 24Z",
    fill: "#FDC228"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24H39C39.2652 24 39.5196 24.1054 39.7071 24.2929C39.8946 24.4804 40 24.7348 40 25V47C40 47.2652 39.8946 47.5196 39.7071 47.7071C39.5196 47.8946 39.2652 48 39 48H33V24Z",
    fill: "#3F3D56"
  })));
};
export default SvgCircle;